module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#photo",
      toString: function () {
        return this.url;
      }
    }